import validate from 'validate.js'
const constraints = {
    price: {
	presence: true,
	numericality: {
	    greaterThan: 0,
	    notGreaterThan: {code: 'greaterThan', minimum: 0}
	}
    }
}

export default fields =>  validate(fields, constraints, {fullMessages: false}) || {}
